import { render, staticRenderFns } from "./editAds.vue?vue&type=template&id=79ad66be&scoped=true&"
import script from "./editAds.vue?vue&type=script&lang=ts&"
export * from "./editAds.vue?vue&type=script&lang=ts&"
import style0 from "./editAds.vue?vue&type=style&index=0&id=79ad66be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad66be",
  null
  
)

export default component.exports